module.exports = __webpack_public_path__ + "static/media/SendV2.823aaec0.svg";